import { Component } from '@angular/core';

@Component({
    selector: 'app-drivers',
    templateUrl: './drivers.component.html',
    styleUrl: './drivers.component.css',
    standalone: false
})
export class DriversComponent {

}
